import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { PlayCircleOutline } from "@mui/icons-material";

const About = () => {
  return (
    <Box sx={{ background: "radial-gradient(circle, #1F6788,#161623)", width: "100%", padding: "40px 0" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          padding: { xs: "20px 0", sm: "30px", md: "40px 5%" },
          gap: { xs: "20px", sm: "30px", md: "40px" },
          width: "100%",
          maxWidth: "1200px",
          backgroundColor: "#B0E0E6",
          margin: "0 auto",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        {/* Image Section */}
        <Box
          sx={{
            flex: 1,
            width: "100%",
            maxWidth: { xs: "100%", md: "50%" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              border: "4px solid white",
              borderRadius: "12px",
              overflow: "hidden",
              width: "100%",
              maxWidth: "500px",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/image/about2ndimage.jpg`} // update path accordingly
              alt="About Us"
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </Box>
        </Box>

        {/* Text Section */}
        <Box
          sx={{
            flex: 1,
            maxWidth: { xs: "100%", md: "50%" },
            textAlign: { xs: "left", md: "left" },
            padding: { xs: "0 10px", sm: "0" },
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "20px", sm: "24px", md: "28px" },
              color: "black",
            }}
          >
            We are <span style={{ color: "black" }}>TECH INFORMATIC SOLUTIONS,</span>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              marginTop: "10px",
              lineHeight: 1.6,
              fontSize: { xs: "14px", sm: "16px", md: "18px" },
              color: "black",
            }}
          >
            An emerging global leader in IT services and pioneered the
            pace-setting 4th generation IT services model, with its headquarters in the USA. Emploitech
            has senior executives – such as client partners, practice heads, and program managers – based
            close to our clients in the US and India who are tightly integrated with our robust Level V offshore
            capability by a leading analyst firm.
          </Typography>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "red",
              color: "white",
              borderRadius: "30px",
              padding: "10px 20px",
              marginTop: "20px",
              textTransform: "none",
              fontWeight: "bold",
              fontSize: { xs: "14px", sm: "16px" },
              "&:hover": { backgroundColor: "#d00000" },
            }}
            endIcon={<PlayCircleOutline />}
          >
            Know More About Us
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default About;
